import React, { lazy, Suspense, useEffect, useState } from 'react'
import { Box, CircularProgress, Grid, Stack } from '@mui/material'
import PageLayoutV2 from 'common/Layout/Page/PageLayoutV2'

import ColorBox from '../../../../../common/Box/ColorWhiteBox'

import OrderDetailsProgressMain from './components/OrderDetailsProgress/OrderDetailsProgressMain'
import mockDataOrder from './mockDataOrder'

const Step1Provision = lazy(
  () =>
    import(
      './components/ManualDeliveryPage/MainDeliveryFlowSteps/Step1Provisioning'
    )
)

const Step2DeliverySchedule = lazy(
  () =>
    import(
      './components/ManualDeliveryPage/MainDeliveryFlowSteps/Step2ScheduleDelivery'
    )
)

const Step3DeliveryReady = lazy(
  () =>
    import(
      './components/ManualDeliveryPage/MainDeliveryFlowSteps/Step3ReadyForDelivery'
    )
)

export default function IndividualOrderPage() {
  const { MOCK_ORDER_STATUS } = mockDataOrder
  const [activeStep, setActiveStep] = useState(0)

  //depending on status, show what is the active component here

  useEffect(() => {
    switch (MOCK_ORDER_STATUS.orderStatus) {
      case 'preparingSims':
        setActiveStep(0)
        break
      case 'deliveryScheduled':
        setActiveStep(1)
        break
      case 'deliveryReady':
        setActiveStep(2)
        break
      default:
        setActiveStep(0)
    }
  }, [])

  return (
    <PageLayoutV2 header='Individual Order'>
      <Stack direction='row' justifyContent='space-between'>
        <Box sx={{ width: '70%' }}>
          <ColorBox>
            <Box>
              {activeStep === 0 && (
                <Suspense fallback={<CircularProgress />}>
                  <Step1Provision
                    mockOrderStatus={MOCK_ORDER_STATUS}
                    activeStep={activeStep}
                  />
                </Suspense>
              )}

              {activeStep === 1 && (
                <Suspense fallback={<CircularProgress />}>
                  <Step2DeliverySchedule
                    mockOrderStatus={MOCK_ORDER_STATUS}
                    activeStep={activeStep}
                  />
                </Suspense>
              )}

              {activeStep === 2 && (
                <Suspense fallback={<CircularProgress />}>
                  <Step3DeliveryReady activeStep={activeStep} />
                </Suspense>
              )}
            </Box>
          </ColorBox>
        </Box>

        <Grid container spacing={3} direction='column' sx={{ width: '30%' }}>
          <OrderDetailsProgressMain />
        </Grid>
      </Stack>
    </PageLayoutV2>
  )
}
